import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DailyAttendanceService } from '../../Model/WebAttendance/daily-attendance.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../Model/Common/common.service';

@Component({
  selector: 'app-reliever',
  standalone: true,
  imports: [DataTablesModule, CommonModule],
  templateUrl: './reliever.component.html',
  styleUrl: './reliever.component.scss'
})
export class RelieverComponent {
  @Input() dData: any;
  @Output() modalData = new EventEmitter<string>();
  Relievers = [] as any;


  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private attendance: DailyAttendanceService,
    private activeModal: NgbActiveModal,
    protected common: CommonService
  ) { 
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit() {
    console.log(this.dData);
    this.AddReliever();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  AddReliever() {
    try {
      this.Relievers = [];
      if (this.dtElement) {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
      }
      this.attendance.Add_Reliever({
        SiteID: this.dData.SiteId,
        Date: this.dData.Date
      }).subscribe({
        next: (response) => {
          console.log(response);
          this.Relievers = response.GetRelieverForAndroid;
          if (this.dtElement) {
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
              this.dtTrigger.next(null);
            });
          }
        }
      })      
    } catch (error) {
      console.log(error);
    }
  }

  close() {
    this.activeModal.close();
  }

  Add(Reliever: any){
    Reliever.DailyAttendanceInOutID = 0,
    Reliever.BranchMasterID = null,
    Reliever.BranchName = "",
    Reliever.ClientGroupMasterID = 0,
    Reliever.ClientGroupName= "",
    Reliever.SiteName= "",
    Reliever.DesignationMasterID= null,
    Reliever.DesignationName= "",
    Reliever.DutyMasterID= null,
    Reliever.DutyName= "",
    Reliever.ShiftMasterID= null,
    Reliever.ShiftTitle= "",
    Reliever.OpenMonth= "",
    Reliever.OpenYear="",
    Reliever.AttendanceRemark= "",
    Reliever.RelieverFlag= null,
    Reliever.InTime= "",
    Reliever.OutTime = "",
    Reliever.DailyAttendancePhoto= "",
    Reliever.DailyAttendancePhotoOut= "",
    Reliever.ShiftInTime= "",
    Reliever.ShiftOutTime= "",
    Reliever.OrderBy= 0,
    Reliever.SiteMasterId = this.dData.SiteId;
    this.activeModal.close(Reliever);
    // this.modalData.emit(Reliever);
    // console.log(Reliever);
    // this.activeModal.close();
  }

}
